import React from "react";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { DesktopMinWidth } from "../../ScreenChecker";
import { FormattedMessage } from "react-intl";
import { Element } from "react-scroll";

import { StyledContact } from "./Contact.styled";

const Contact = () => {
  const isDesktop = useMediaQuery({ minWidth: DesktopMinWidth });

  return (
    <Element name="contact">
      <StyledContact isDesktop={isDesktop}>
        <div className="footer">
          <div className="links">
            <Link to="/private-and-cookie" className="text">
              <FormattedMessage id="contact_private-and-cookie" />
            </Link>
            <span className="sep">|</span>
            <Link to="/terms-of-service" className="text">
              <FormattedMessage id="contact_terms-of-service" />
            </Link>
          </div>

          <div className="company">
            <FormattedMessage id="footer_company" />
          </div>

          <div className="legal">
            <div className="legal-line">
              <span>
                <FormattedMessage id="footer_ceo" />
              </span>
              <span className="dot">·</span>
              <span>
                <FormattedMessage id="footer_biz_reg" />
              </span>
              <span className="dot">·</span>
              <span>
                <FormattedMessage id="footer_mailorder" />
              </span>
            </div>
            <div className="legal-line">
              <FormattedMessage id="contact_content1_1" />
            </div>
            <div className="legal-line">
              <FormattedMessage id="contact_content1_2" />
            </div>
            <div className="legal-line">
              <span>
                <FormattedMessage id="footer_tel" />
              </span>
              <span className="dot">·</span>
              <a href="mailto:info@dyphi.com">
                <FormattedMessage id="contact_content2_1" />
              </a>
            </div>
          </div>

          <div className="copyright">
            <FormattedMessage id="contact_copyright" />
          </div>
        </div>
      </StyledContact>
    </Element>
  );
};

export default Contact;
